import * as DATE_PERIOD from "constants/dateFilter";
import { TAX_YEAR_END_TYPES } from "constants/bookkeeping";
import { OptionData } from "components/DesignSystem/Combobox/Combobox";
import dayjs from "dayjs";
import { getDateRange, DateRangeValue } from "utils/getDateRange";

export const baseDatePeriod = [
  { label: "Current month", value: DATE_PERIOD.CURRENT_MONTH },
  { label: "Last month", value: DATE_PERIOD.LAST_MONTH },
  { label: "Last 3 months", value: DATE_PERIOD.LAST_3_MONTHS },
  { label: "Current quarter", value: DATE_PERIOD.CURRENT_QUARTER },
  { label: "Last quarter", value: DATE_PERIOD.LAST_QUARTER },
  {
    label: `Current year`,
    value: DATE_PERIOD.CURRENT_TAX_YEAR,
  },
  {
    label: `Last year`,
    value: DATE_PERIOD.LAST_TAX_YEAR,
  },
];

export const getDatePeriod = [
  { label: "Last 30 days", value: DATE_PERIOD.LAST_30_DAYS },
  { label: "Last 90 days", value: DATE_PERIOD.LAST_90_DAYS },
  ...baseDatePeriod,
];

export const getDatePeriodWithSetting = (
  periods: OptionData[],
  taxYearEnd?: TAX_YEAR_END_TYPES,
  bookkeepingStartDate?: string
): OptionData[] => {
  if (!bookkeepingStartDate) return periods;

  const bkStartDate = dayjs(bookkeepingStartDate);

  return periods.map((period) => {
    if (period.value === "CUSTOM") return period;

    const { endDate } = getDateRange(
      period.value as DateRangeValue,
      taxYearEnd
    );

    if (endDate.isBefore(bkStartDate, "day")) {
      return {
        ...period,
        disableOption: true,
        data: "This period ends before the bookkeeping start date",
      };
    }

    return period;
  });
};
